import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { MAZE_GOAL_SOURCE_HANDLES } from '../mazeGoalHandles';
import { MazeGoalNodeView } from '../views/MazeGoalNode';

export const mazeGoalDefinition: NodeDefinition<'mazeGoal'> = {
  label: 'At Goal?',
  showInPalette: true,
  mazeOnly: true,
  paletteImageKind: 'mazeGoal',
  paletteColor: 'bg-amber-100 border-amber-500 text-amber-700',
  miniMapColor: '#f59e0b',
  defaultData: { label: 'At Goal?' },
  view: MazeGoalNodeView,
  run: (_node, ctx, log) => {
    if (!ctx.mazeControl?.isAtGoal) {
      log('[At Goal?] エラー: 迷路アプリでのみ使用できます');
      return { nextHandle: null };
    }
    const atGoal = ctx.mazeControl.isAtGoal();
    const nextHandle = atGoal ? MAZE_GOAL_SOURCE_HANDLES.true : MAZE_GOAL_SOURCE_HANDLES.false;
    log(`[At Goal?] 現在位置はゴール${atGoal ? 'です' : 'ではありません'}`);
    return { nextHandle, branchLabel: atGoal ? 'true' : 'false' };
  },
  help: {
    title: [t('ゴールですか？')],
    description: [
      t('ロボットの'),
      r('現在', 'げんざい'),
      r('位置', 'いち'),
      t('がゴールかを'),
      r('判断', 'はんだん'),
      t('し、trueまたはfalseへ'),
      r('分岐', 'ぶんき'),
      t('します。'),
    ],
  },
};
